import { MaterialReactTable } from 'material-react-table'

import { PageWrap } from '@/components'
import { useTable } from '@/hooks'
import { DependenciesBottomToolbar } from '@/pages/User/pages/Home/components/Dependencies/components/DependenciesBottomToolbar'
import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab'
import { useGetNodeRelationsUsingGetQuery } from '@/rtkApi'
import { RelationDto } from '@/rtkApi/mddApiSliceGenerated'

import { useDepColumns } from './hooks'

export const NewDependencies = () => {
	const {
		state: { editMode, node },
	} = useDetailTabContext()

	const { data, isLoading, refetch } = useGetNodeRelationsUsingGetQuery({
		structureId: node.id,
	})

	const columns = useDepColumns()

	const table = useTable<RelationDto>({
		columns,
		data: data || [],
		editMode,
		options: {
			enableRowActions: false,
			enableRowOrdering: false,
			state: {
				isLoading,
			},
			renderBottomToolbar: (
				<DependenciesBottomToolbar
					node={node}
					refetch={refetch}
					editMode={editMode}
				/>
			),
			enableTopToolbar: true,
			enableGlobalFilter: true,
		},
	})

	return (
		<PageWrap>
			<MaterialReactTable table={table} />
		</PageWrap>
	)
}
